const submissionDateFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Ulaanbaatar',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

export const formatRegistrationSubmittedAt = (value) => {
  if (typeof value !== 'string' || !value.trim()) return '-';

  const timestamp = value.trim().replace(' ', 'T');
  // Registration timestamps are UTC, but PostgreSQL TIMESTAMP / pgtype.Timestamp
  // serializes them without a timezone. Preserve explicit offsets when present.
  const hasTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(timestamp);
  const date = new Date(hasTimeZone ? timestamp : `${timestamp}Z`);

  return Number.isNaN(date.getTime()) ? '-' : submissionDateFormatter.format(date);
};
